module.exports = __webpack_public_path__ + "img/ai-img-qcode.7e419c57.png";